{
  "processing": "กำลังดำเนินการยืนยัน...",
  "loadingIframe": "กำลังโหลดการยืนยันตัวตน...",
  "issueTitle": "ปัญหาการยืนยันตัวตน",
  "notConfigured": "คลังสินค้านี้ยังไม่ได้ตั้งค่าการยืนยันตัวตนอย่างถูกต้อง",
  "notSuccessful": "การยืนยันตัวตนไม่สำเร็จ โปรดลองอีกครั้งหรือติดต่อคลังสินค้า",
  "couldNotCompleteProceed": "ไม่สามารถยืนยันตัวตนให้เสร็จสมบูรณ์ได้ แต่คุณสามารถเช็กอินต่อได้",
  "processFailed": "ดำเนินการยืนยันตัวตนไม่สำเร็จ โปรดลองอีกครั้ง",
  "processingFailedProceed": "การประมวลผลการยืนยันตัวตนล้มเหลว แต่คุณสามารถเช็กอินต่อได้",
  "genericError": "เกิดข้อผิดพลาดระหว่างการยืนยันตัวตน โปรดลองอีกครั้ง",
  "issueProceed": "การยืนยันตัวตนพบปัญหา แต่คุณสามารถเช็กอินต่อได้",
  "requiredTryAgain": "ต้องยืนยันตัวตนเพื่อเช็กอินให้เสร็จสมบูรณ์ โปรดลองอีกครั้ง",
  "checkInFailedTitle": "ไม่สามารถเช็กอินได้",
  "checkInFailedMessage": "ไม่สามารถตรวจสอบบัตรประจำตัวของคุณได้"
}
